import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from '../skeleton/skeleton.component';

interface SkeletonCell {
  width: string;
  height: string;
  rounded?: 'sm' | 'md' | 'full';
}

@Component({
  selector: 'app-encounter-skeleton',
  standalone: true,
  imports: [CommonModule, SkeletonComponent],
  templateUrl: './encounter-skeleton.component.html',
  styleUrl: './encounter-skeleton.component.scss'
})
export class EncounterSkeletonComponent {
  @Input() count: number = 8;
  @Input() showHeader: boolean = false;
  @Input() showWrapper: boolean = false;

  readonly skeletonCells: SkeletonCell[] = [
    { width: '64px', height: '1.25rem', rounded: 'full' },
    { width: '70%', height: '1rem' },
    { width: '50%', height: '1rem' },
    { width: '80%', height: '1rem' },
    { width: '60%', height: '1rem' },
    { width: '65%', height: '1rem' },
    { width: '30%', height: '1rem' },
    { width: '50%', height: '1rem' },
  ];

  get placeholders(): number[] {
    return Array.from({ length: this.count }, (_, i) => i);
  }
}
